'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    // Always log to console so it appears in DO runtime logs
    console.error('[DASHBOARD ERROR] Global error caught:', error?.message || error);

    // Also send to Sentry in production
    if (process.env.NEXT_PUBLIC_ENV === 'production') {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <html>
      <body>
        <div className="flex items-center justify-center min-h-screen bg-canvas-alt">
          <div className="text-center px-4 max-w-md">
            <div className="mb-6">
              <svg
                className="mx-auto h-16 w-16 text-danger"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-ink mb-4">
              Something went wrong!
            </h2>
            <p className="text-muted mb-6">
              We apologize for the inconvenience. Our team has been notified and is working on a fix.
            </p>
            <button
              onClick={() => reset()}
              className="px-6 py-3 bg-inversePurple-100 text-white rounded-lg hover:bg-inversePurple-200 transition-colors"
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
